
import React from 'react';
//import { Link } from "react-router-dom";
import axios from "axios";
//import {Redirect} from 'react-router-dom';
import logoreg from "../abc.png"
import Path from "./config";

class ForgotPassword extends React.Component{
    constructor(props){
        super(props);
  
        this.state = {
            sbg_mobile_no : "",
        }
   
      }
      componentDidMount(){
        //console.log("history===========");
        
      }
     
      mobileHandler=(e)=>
      {
         this.setState
         ({sbg_mobile_no:e.target.value})
      }
     
     
      submitClick=(e)=>{
        //console.log(" Name=",this.state.sbg_mobile_no);
        //console.log("Email=",this.state.sbg_email_id);
        e.preventDefault();
        let tempStr="sbg_mobile_no="+this.state.sbg_mobile_no
        // console.log(Login)
        axios.post(Path+`Suchi_bride_groom_forgotpass.php?`+tempStr)
         .then(function (response) 
         {
             //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
            
            if(response.data.Sucess === "Present"){
                localStorage.setItem("userId",response.data.sbg_id);
                localStorage.setItem("phoneId",this.state.sbg_mobile_no);
                alert("आपल्या नोंदणीकृत मोबाइल क्रमांकावर पासवर्ड पाठविला आहे . ");
                this.props.history.push(`./Login`);
            }else if(response.data.Sucess === "blacklisted"){
                //  document.getElementById("error").innerHTML = "तुमचे अकाउंट बंद करण्यात आले आहे सुरू करण्यासाठी कृपया लेवा शुभमंगल ऑफिस ला संपर्क करावा.";
                 alert("तुमचे अकाउंट बंद करण्यात आले आहे सुरू करण्यासाठी कृपया लेवा शुभमंगल ऑफिस ला संपर्क करावा.");
              }
            else
            {
                alert("क्रमांक आमच्याकडे नोंदणीकृत नाही, कृपया नोंदणी करा.");
                this.props.history.push(`./`);
            }
         }.bind(this))
        }

        cancleClick=()=>
        {
            this.props.history.push(`/`);
        }
        

    render(){
       
    return (
        <>
        <div className="container-fluid">
        <span className="align-middle d-flex justify-content-center"><img src={logoreg} alt="logo" style={{width:"300px"}}></img></span>

            <div className="row justify-content-md-center my-5 ">
   
                <div className="col-md-5 border  border-5 p-3 mb-2 bg-light text-dark">
                    <div className="mb-3  ">
                    <span className="d-block p-2 bg-danger text-white text-md-center text-capitalize">Forgot Password</span>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="formGroupExampleInput" className="form-label">मोबईल नंबर </label>
                        <input type="text" className="form-control" value={this.state.sbg_mobile_no} onChange={this.mobileHandler} placeholder="Mobile Number" />
                    </div>
                  
                   
                    <div className="mb-3 text-center my-5">
                        {/* <Link to="/Otpcomfirm"> */}
                        <button type="button" className="btn btn-success m-2" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}> Submit ▶️ </button>
                        {/* </Link> */}
                        <button type="button" className="btn btn-primary" onClick={()=>this.cancleClick()}> Cancel ❎ </button>
                    </div>
                </div>
            </div>
   
        </div>
        
        </>
    )}
}

export default ForgotPassword

